import { createContext } from 'react';
import { UserInfo } from './adapters/types';

export type AuthError = string | null;
export type AuthUserInfo = UserInfo | null;
export type AuthShowLoginWidget = () => void;

export interface AuthHook {
  authError: AuthError;
  authToken?: string;
  customerId?: string;
  isValidating: boolean;
  loginCallbackUrl: string;
  userInfo: AuthUserInfo;
  logout?: () => void;
  clearTokens?: () => void;
  resetPassword?: () => void;
  validateSession?: () => void;
}

export interface AuthContext extends AuthHook {
  showLoginWidget?: AuthShowLoginWidget;
}

const stub = (): never => {
  throw new Error('Component must have an upstream <AuthProvider> parent');
};

const initialContext: AuthContext = {
  authError: null,
  isValidating: true,
  loginCallbackUrl: '',
  userInfo: null,
  logout: stub,
  resetPassword: stub,
  showLoginWidget: stub,
  validateSession: stub,
};

export default createContext<AuthContext>(initialContext);
